module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#filter",
      toString: function () {
        return this.url;
      }
    }